import { render, staticRenderFns } from "./editSentencePage.vue?vue&type=template&id=3ebd5ff9&"
import script from "./editSentencePage.vue?vue&type=script&lang=js&"
export * from "./editSentencePage.vue?vue&type=script&lang=js&"
import style0 from "./editSentencePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports